import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class WithholdingsPermissions extends BaseScenesPermissions {
    constructor({ show = false, enabled = true } = {}) {
        super({ show, enabled })
    }
}

export default WithholdingsPermissions
